if (!customElements.get('et-personalization')) {
customElements.define('et-personalization', class extends HTMLElement {
connectedCallback() {
this.formElement = this.closest('form');
this.validateSubmit = event => {
this.sync();
if (!this.formElement.reportValidity()) {event.preventDefault();event.stopImmediatePropagation();}
};
this.formElement.addEventListener('submit', this.validateSubmit, true);
this.variantListener = () => this.sync();
this.formElement.querySelector('[name="id"]')?.addEventListener('change', this.variantListener);
this.later = this.querySelector('[data-stats-later]');
this.later?.addEventListener('change', this.variantListener);
this.sync();
}
disconnectedCallback() {
this.formElement?.removeEventListener('submit',this.validateSubmit,true);
this.formElement?.querySelector('[name="id"]')?.removeEventListener('change',this.variantListener);
this.later?.removeEventListener('change',this.variantListener);
}
sync() {
if (this.dataset.baby !== 'true') return;
const variants = JSON.parse(this.querySelector('[data-variants]').textContent);
const id = this.formElement.querySelector('[name="id"]').value;
const engraved = variants.find(v => String(v.id) === id)?.title.includes('Birth stats engraved') || false;
const later = engraved && this.later.checked;
this.querySelector('[data-birth-stats]').hidden = !engraved;
this.later.disabled = !engraved;
this.querySelector('[data-stats-fields]').hidden = later;
this.querySelector('[data-later-note]').hidden = !later;
this.querySelectorAll('[data-stat]').forEach(field => {field.disabled = !engraved || later;field.required = engraved && !later;});
}
});
}